import { MessageSourceProps, withMessages } from 'react-message-source';
import * as React from 'react';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import styled from 'styled-components';
import { RouterProps } from 'react-router';
import AutomaticBillReminderTableView from 'components/reminder/AutomaticBillReminderTableView';
import { AutomaticReminderRequest, AutomaticReminderResponse } from 'ts-types/api.types';
import { getUnpaidBills } from 'services/billServices';
import axios from 'services/http';
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends MessageSourceProps, PatientConsumerRenderProps, RouterProps, AuthConsumerRenderProps {

}

interface State {
  billsLoading: boolean,
  bills: Array<AutomaticReminderResponse>,
  cancelTokenSource: CancelTokenSource
}

class AutomaticBillReminderView extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      bills: [],
      billsLoading: true,
      cancelTokenSource
    }
  }

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  render(): React.ReactNode {
    const {currentPatient, getMessage, onPatientRefresh} = this.props;
    const {bills, billsLoading} = this.state;

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.automaticReminder")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledPraxSegment>
            <AutomaticBillReminderTableView
                bills={bills}
                billsLoading={billsLoading}
                currentPatient={currentPatient}
                onPatientRefresh={onPatientRefresh}
                getUnpaidBills={this.getUnpaidBills}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  }

  getUnpaidBills = (billDate: string) => {
    const {currentUser} = this.props;
    const {cancelTokenSource} = this.state;

    const request: Partial<AutomaticReminderRequest> = {
      billDate: billDate,
      mandateId: currentUser!.userConfig.mandateId
    };

    this.setState({
      billsLoading: true
    });

    getUnpaidBills(request, cancelTokenSource).then(response => {
      this.setState({
        bills: response
      });
    }).finally(() => {
      this.setState({billsLoading: false});
    });
  }

}

export default withRouterWorkaround(withAuthContext(withPatientContext(withMessages(AutomaticBillReminderView))));
